package ru.arty_bikini.crm_frontend.network

class EntitySaveHelper {

    suspend fun save(key: String, entity: Entity, now: Boolean, action: suspend () -> Unit) {

    }

}
